<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <BitQLoginPage :service_title="service_title" :showcase_id="showcase_id"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BitQLoginPage from '@/components/bitq/BitQLoginPage'

export default {
  name: 'BitQCorsi',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Corsi OnLine", link : 'conv-bitq-corsi' } ],

        // Nome welfarebit del servizio
        service_title : "Corsi OnLine",

        // Identificativo della vetrina ( fornito da BitQ )
        showcase_id : 115
    }
  },
  components: {
    PageTagline,
    BitQLoginPage
  }
}
</script>

<style scoped></style>